import { combinatorOptions } from 'modules/queryBuilder/legacyQueryBuilder/utils/combinators';
import {
  CombinatorDropdownContainer,
  StyledCoreDropdown,
  TextContainer,
} from './CombinatorDropdown.styled';

// type Props = {
//   /** Text to append (Insert After) dropdown. */
//   appendText: string,
//   /** Additional content. */
//   children: node,
//   /** Additional classes. */
//   className: string,
//   /** Available fields for the selected property. */
//   combinators: [],
//   /** if dropdown is read only */
//   isReadOnly: boolean,
//   /**
//    * Callback function when value changes.
//    */
//   onChange: (e: {}, props: {}) => {},
//   /** Text to prepend (Insert Before) dropdown. */
//   prependText: string,
//   /** Value of the selected field. */
//   value: string,
// };

const CombinatorDropdown = ({
  appendText = 'that meet the following criteria',
  children,
  className,
  combinators = combinatorOptions,
  onChange,
  prependText = '',
  value,
  isReadOnly = false,
}) => {
  const hasText = appendText || prependText;
  const dropdown = (
    <StyledCoreDropdown
      className={hasText ? '' : className}
      inline
      onChange={onChange}
      options={combinators}
      value={value}
      disabled={isReadOnly}
    />
  );
  return hasText ? (
    <CombinatorDropdownContainer className={className} data-role="combinator">
      <TextContainer>{prependText}</TextContainer>
      {dropdown}
      <TextContainer>{appendText}</TextContainer>
      {children}
    </CombinatorDropdownContainer>
  ) : (
    dropdown
  );
};

export default CombinatorDropdown;
